import React from 'react';

import { TextareaInput } from '../form-input';

export const MediaIdentifierInput: React.FC<{
  id: string;
  value: string;
  isDisabled: boolean;
  handleInputChange: (
    value: string,
    type: 'media-only-identifier' | 'question' | 'answer',
    answerResId?: string | undefined
  ) => void;
}> = ({ id, value, isDisabled, handleInputChange }) => {
  const counterColorClass = React.useMemo(() => {
    if (value.length < 5) return 'text-success';
    if (value.length < 10) return 'text-warning';

    return 'text-danger';
  }, [value.length]);

  return (
    <div className={'d-flex gap-2 align-items-center'}>
      <TextareaInput
        id={id}
        value={value}
        onChange={(e) =>
          handleInputChange(e.target.value as string, 'media-only-identifier')
        }
        rows={1}
        autoSize
        disabled={isDisabled}
      />
      <span
        className={counterColorClass}
        style={{
          width: '30px'
        }}>
        {15 - value.length}
      </span>
    </div>
  );
};
